import { useEffect, useState } from "react";
import api, { BACKEND_URL } from "@/lib/api";

const cache = { url: null, promise: null };
const resolve = (u) => (u?.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export function useBrandLogo() {
  const [logo, setLogo] = useState(cache.url);
  useEffect(() => {
    if (cache.url) { setLogo(cache.url); return; }
    if (!cache.promise) {
      cache.promise = api.get("/branding").then(r => {
        cache.url = resolve(r.data.logo_url) || null;
        return cache.url;
      }).catch(() => null);
    }
    cache.promise.then(u => setLogo(u));
  }, []);
  return logo;
}

export function BrandLogo({ className = "", fallback = "M" }) {
  const url = useBrandLogo();
  if (url) return <img src={url} alt="MLILY" className={className} />;
  return (
    <div className={`${className} bg-[#003DA5] text-white grid place-items-center font-heading font-bold`}>
      {fallback}
    </div>
  );
}
